import PropTypes from 'prop-types';
import classnames from 'clsx';

import css from './auth-flow-progress-bar.module.scss';

const AuthFlowProgressBar = ({ step }) => (
  <div
    data-testid="authFlowProgressBarContainer"
    className={css.progressBarContainer}
  >
    <ul data-testid="authFlowProgressBar" className={css.progressBar}>
      <li
        className={classnames(css.progressBarStep, {
          [css.active]: step > 0,
        })}
      />
      <li
        className={classnames(css.progressBarStep, {
          [css.active]: step > 1,
        })}
      />
      <li
        className={classnames(css.progressBarStep, {
          [css.active]: step > 2,
        })}
      />
    </ul>
  </div>
);

AuthFlowProgressBar.propTypes = {
  step: PropTypes.number,
};

export default AuthFlowProgressBar;
